// Mock Stripe service for staging
// TODO: Replace with real Stripe SDK when ready for production

export async function createPaymentIntent(planId, amount) {
  console.log('[Stripe Mock] Creating payment intent for:', planId, 'amount:', amount);
  // Simulate API delay
  await new Promise(r => setTimeout(r, 300));
  return {
    clientSecret: 'mock_client_secret_' + Date.now(),
    orderId: 'order_' + Date.now()
  };
}

export async function confirmPayment({ clientSecret, orderId, paymentMethodId }) {
  console.log('[Stripe Mock] Confirming payment:', { clientSecret, orderId, paymentMethodId });
  // Simulate API delay
  await new Promise(r => setTimeout(r, 500));
  // Simulate successful payment
  return { success: true, orderId };
}

export const STRIPE_PUBLIC_KEY = 'pk_test_mock';
export const STRIPE_SECRET_KEY = 'sk_test_mock';